module.exports = __webpack_public_path__ + "static/img/sys-5.74bc93b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys-5.png
// module id = 9Bm4
// module chunks = 1